interface ILocaleStringMap {
	[locale: string]: string;
}

export class StaticStrings {
	protected static _g_please_switch_browser: ILocaleStringMap = {
		en: 'Please switch browser. This one is not supported.',
		sv: 'Var snäll och byt webbläsare. Den nuvarande stöds ej.',
	};

	protected static _g_please_update_browser: ILocaleStringMap = {
		cs: 'Aktualizujte prosím prohlížeč pro lepší výkon.',
		ru: 'Пожалуйста, обновити версию браузера для улучшения производительности.',
		el: 'Ενημερώστε το πρόγραμμα περιήγησης για καλύτερη απόδοση.',
		id: 'Perbarui browser untuk kinerja yang lebih baik.',
		nl: 'Werk de browser bij voor betere prestaties.',
		pt: 'Por favor, atualize o navegador para um melhor desempenho.',
		sl: 'Za boljše delovanje posodobite brskalnik.',
		hr: 'Ažurirajte preglednik za bolje performanse.',
		no: 'Oppdater nettleseren for bedre ytelse.',
		'pt-BR': 'Por favor, atualize o navegador para um melhor desempenho.',
		de: 'Bitte aktualisieren Sie den Browser für eine bessere Leistung.',
		bg: 'Моля, актуализирайте браузъра за по-добра производителност.',
		ja: 'パフォーマンスを向上させるには、ブラウザを更新してください。',
		th: 'โปรดอัปเดตเบราว์เซอร์เพื่อประสิทธิภาพที่ดีขึ้น',
		pl: 'Zaktualizuj przeglądarkę, aby uzyskać lepszą wydajność.',
		es: 'Actualice el navegador para un mejor rendimiento.',
		fr: 'Veuillez mettre à jour votre navigateur pour de meilleures performances.',
		ko: '더 나은 성능을 위해 브라우저를 업데이트하십시오.',
		vi: 'Vui lòng cập nhật trình duyệt để có hiệu suất tốt hơn.',
		lv: 'Lai uzlabotu veiktspēju, lūdzu, atjauniniet pārlūku.',
		lt: 'Norėdami pagerinti našumą, atnaujinkite naršyklę.',
		fi: 'Päivitä selain suorituskyvyn parantamiseksi.',
		hu: 'Kérjük, frissítse a böngészőt a jobb teljesítmény érdekében.',
		en: 'Please update browser for better performance.',
		sk: 'Aktualizujte prehliadač, aby ste dosiahli lepší výkon.',
		it: 'Aggiorna il browser per prestazioni migliori.',
		da: 'Opdater browseren for bedre ydelse.',
		sv: 'Uppdatera webbläsaren för bättre prestanda.',
		tr: 'Lütfen daha iyi performans için tarayıcıyı güncelleyin.',
		'zh-cn': '请开启硬件加速以更流畅的运行游戏。',
		'zh-tw': '請開啟硬件加速以更流暢的運行遊戲。',
	};

	protected static _g_please_enable_hardware_acceleration: ILocaleStringMap = {
		cs: 'Chcete-li dosáhnout lepšího výkonu hry, povolte hardwarovou akceleraci.',
		ru: 'Пожалуйста, включите поддержку аппаратного ускорения в браузере для улучшения производительнсти.',
		el: 'Ενεργοποιήστε την επιτάχυνση υλικού για καλύτερη απόδοση του παιχνιδιού.',
		id: 'Harap aktifkan akselerasi perangkat keras untuk kinerja game yang lebih baik.',
		nl: 'Schakel hardwareversnelling in voor betere spelprestaties.',
		pt: 'Por favor, ative a aceleração de hardware para um melhor desempenho do jogo.',
		sl: 'Za boljše delovanje igre omogočite pospeševanje strojne opreme.',
		hr: 'Omogućite hardversko ubrzanje za bolje performanse igre.',
		no: 'Aktiver maskinvareakselerasjon for bedre spillytelse.',
		'pt-br': 'Por favor, ative a aceleração de hardware para um melhor desempenho do jogo.',
		de: 'Aktivieren Sie die Hardwarebeschleunigung für eine bessere Spieleleistung.',
		bg: 'Моля, активирайте хардуерното ускорение за по-добра производителност на играта.',
		ja: 'ゲームのパフォーマンスを向上させるには、ハードウェアアクセラレーションを有効にしてください。',
		th: 'โปรดเปิดใช้งานการเร่งด้วยฮาร์ดแวร์เพื่อประสิทธิภาพของเกมที่ดีขึ้น',
		pl: 'Włącz przyspieszenie sprzętowe, aby uzyskać lepszą wydajność gry.',
		es: 'Habilite la aceleración de hardware para un mejor rendimiento del juego.',
		fr: "Veuillez activer l'accélération matérielle pour améliorer les performances du jeu.",
		ko: '더 나은 성능을 위해 브라우저를 업데이트하십시오.',
		vi: 'Vui lòng kích hoạt tăng tốc phần cứng để có hiệu suất trò chơi tốt hơn.',
		lv: 'Lūdzu, iespējojiet aparatūras paātrinājumu, lai spēle būtu labāka.',
		lt: 'Prašome įgalinti aparatinės įrangos pagreitį, kad žaidimas būtų geresnis.',
		fi: 'Ota käyttöön laitteistokiihdytys pelin suorituskyvyn parantamiseksi.',
		hu: 'A játék jobb teljesítményéhez engedélyezze a hardveres gyorsítást.',
		en: 'Please enable hardware acceleration for better game performance.',
		sk: 'Ak chcete dosiahnuť lepší výkon hry, povoľte hardvérovú akceleráciu.',
		it: "Abilitare l'accelerazione hardware per migliorare le prestazioni del gioco.",
		da: 'Aktivér hardwareacceleration for bedre spilydelse.',
		sv: 'Aktivera maskinvaru-acceleration för bättre spelprestanda.',
		tr: 'Lütfen daha iyi oyun performansı için donanım ivmesini etkinleştirin.',
		'zh-cn': '请更新你的浏览器以更流畅的运行游戏。',
		'zh-tw': '請更新你的瀏覽器以更流暢的運行遊戲。',
	};

	protected static _g_optimized_for_chrome: ILocaleStringMap = {
		cs: 'Tato hra byla optimalizována pro hraní v Chromu.',
		ru: 'Игра оптимизирована для работы в браузере Chrome.',
		el: 'Αυτό το παιχνίδι έχει βελτιστοποιηθεί για αναπαραγωγή στο Chrome.',
		id: 'Game ini telah dioptimalkan untuk dimainkan di Chrome.',
		nl: 'Deze game is geoptimaliseerd om in Chrome te worden gespeeld.',
		pt: 'Este jogo foi otimizado para ser jogado no Chrome.',
		sl: 'Ta igra je bila optimizirana za igranje v Chromu.',
		hr: 'Ova je igra optimizirana za igranje u Chromeu.',
		no: 'Dette spillet er optimalisert for å bli spilt i Chrome.',
		'pt-br': 'Este jogo foi otimizado para ser jogado no Chrome.',
		de: 'Dieses Spiel wurde für Chrome optimiert.',
		bg: 'Тази игра е оптимизирана за игра в Chrome.',
		ja: 'このゲームは、Chromeでプレイできるように最適化されています。',
		th: 'เกมนี้ได้รับการปรับให้เล่นใน Chrome ได้ดีที่สุด',
		pl: 'Ta gra została zoptymalizowana pod kątem grania w Chrome.',
		es: 'Este juego ha sido optimizado para jugarse en Chrome.',
		fr: 'Ce jeu a été optimisé pour être joué dans Chrome.',
		ko: '이 게임은 Chrome에서 재생되도록 최적화되었습니다.',
		vi: 'Trò chơi này đã được tối ưu hóa để chơi trong Chrome.',
		lv: 'Šī spēle ir optimizēta spēlēšanai pārlūkā Chrome.',
		lt: 'Šis žaidimas buvo optimizuotas žaisti „Chrome“.',
		fi: 'Tämä peli on optimoitu pelaamaan Chromessa.',
		hu: 'Ezt a játékot úgy optimalizálták, hogy a Chrome-ban játszhassa.',
		en: 'This game has been optimized to be played in Chrome.',
		sk: 'Táto hra bola optimalizovaná na hranie v prehliadači Chrome.',
		it: 'Questo gioco è stato ottimizzato per essere giocato in Chrome.',
		da: 'Dette spil er optimeret til at blive spillet i Chrome.',
		sv: 'Detta spel har optimerats för att spelas i Chrome.',
		tr: "Bu oyun Chrome'da oynanacak şekilde optimize edilmiştir.",
		'zh-cn': '本游戏在谷歌浏览器运行最优。',
		'zh-tw': '本遊戲在谷歌瀏覽器運行最優。',
	};

	public static updateBrowser(locale: string): string {
		return StaticStrings.GetValidLocaleString(StaticStrings._g_please_update_browser, locale);
	}

	public static hardwareAcceleration(locale: string): string {
		return StaticStrings.GetValidLocaleString(StaticStrings._g_please_enable_hardware_acceleration, locale);
	}

	public static optimizedForChrome(locale: string): string {
		return StaticStrings.GetValidLocaleString(StaticStrings._g_optimized_for_chrome, locale);
	}

	public static switchBrowser(locale: string): string {
		return StaticStrings.GetValidLocaleString(StaticStrings._g_please_switch_browser, locale);
	}
	protected static prettyLocale(locale: string): string {
		if (typeof locale === 'string') {
			return locale.toLowerCase();
		}

		return 'en';
	}

	protected static GetValidLocaleString(stringMap: ILocaleStringMap, locale: string): string {
		return stringMap.hasOwnProperty(StaticStrings.prettyLocale(locale)) ? stringMap[StaticStrings.prettyLocale(locale)] : stringMap.en;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/system/messages/StaticStrings.ts